<template>
  <lazy-cart-order-summary-secondary v-if="$feature.tempOrderSummaryShowGroupedDiscount" />
  <lazy-cart-order-summary v-else />
</template>

<script lang="ts" setup>
const LazyCartOrderSummary = defineAsyncComponent(() => import('#commerce/components/cart/OrderSummary.vue'))
</script>
